import { FC } from 'react'
import MediaCard from './common/MediaCard'
import { Tenant } from 'common/tenant'

type KeyBenefitsCardProps = {
  tenant?: Tenant
}

const KeyBenefitsCard: FC<KeyBenefitsCardProps> = ({ tenant = Tenant.UK }) => {
  const isAU = tenant === Tenant.AU
  const location = isAU ? 'Sydney' : 'London'
  const addressLabel = isAU ? 'Sydney CBD' : 'City'
  return (
    <MediaCard
      className='key-benefits-card'
      image={{
        alt: 'Robot torso with office imagery',
        desktop: {
          dimensions: {
            height: 542,
            width: 488,
          },
          src: '/images/new/robot-holding-mail-v2.png',
        },
        mobile: {
          dimensions: {
            height: 1122,
            width: 696,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageFitPreset='contain-center'
      imageContainerWidth={{ desktop: '47%' }}
      layout={{
        mobile: 'media-top-content-bottom',
      }}
      contentClassName='d-flex flex-1 flex-column px-4 pe-lg-0 ps-lg-20 pt-lg-16 pb-8 fw-semibold mt-lg-0 mt-n16'
    >
      <div className='me-lg-n16'>
        <h2 className='lh-105 fw-semibold mb-6 fs-fluid-40-80 d-block pe-5'>
          {isAU ? 'Key' : 'The Key'} Benefits of a{' '}
          <span className='text-gradient-purple'>Virtual Office Address</span>
        </h2>
        <div className='gap-4 d-flex flex-column'>
          <span className='fs-fluid-20-28'>
            A virtual office plan at Hoxton Mix is ideal for small businesses,
            entrepreneurs, freelancers and startups looking for a prime virtual
            office address in {location}.
          </span>

          <span className='content lh-132 fs-fluid-18-22'>
            Get a desirable address without the need of renting a physical
            office and improve your image with potential clients. With our
            virtual office, you can specify our {addressLabel} address as your
            company's registered address.
          </span>
        </div>
      </div>
    </MediaCard>
  )
}

export default KeyBenefitsCard
